import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
// Update the import path to the correct relative location
import Authmiddleware from "./routes/Authmiddleware.js";
import GlobalProvider from "./context/GlobalContext";

const App = () => {
  return (
    <GlobalProvider>
      <Authmiddleware />
    </GlobalProvider>
  );
};

export default App;

